import {
  ALLMENU,
  BODY,
  BODYCLN,
  BODYCLR,
  BODYORGRIGHT,
  LOGOUT,
  PAGE,
  PROFILE,
  RETOKEN,
  TOKEN
} from '../Constants'

export const GET_TOKEN = 'GET_TOKEN'

export const updateToken = (token, retoken, profile) => {
  return {
    type: GET_TOKEN,
    payload: {
      token,
      profile,
      retoken
    }
  }
}

export const restoreLogin = () => {
  const token = localStorage.getItem(TOKEN)
  const retoken = localStorage.getItem(RETOKEN)

  const profile = JSON.parse(localStorage.getItem(PROFILE))
  return {
    type: GET_TOKEN,
    payload: {
      token,
      profile,
      retoken
    }
  }
}

export const logout = (navigate, path) => {
  return (dispatch) => {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(RETOKEN)
    localStorage.removeItem(PROFILE)
    localStorage.removeItem(PAGE)
    localStorage.removeItem(BODY)
    localStorage.removeItem(BODYCLR)
    localStorage.removeItem(BODYCLN)
    localStorage.removeItem(ALLMENU)
    localStorage.removeItem(BODYORGRIGHT)
    dispatch({
      type: LOGOUT
    })
    navigate(path)
  }
}
